/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { StatusWorkflowItem } from '../../models/status-workflow-item';

export interface StatusWorkflowControllerDeleteStatusWorkflow$Params {
  id: number;
}

export function statusWorkflowControllerDeleteStatusWorkflow(http: HttpClient, rootUrl: string, params: StatusWorkflowControllerDeleteStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
  const rb = new RequestBuilder(rootUrl, statusWorkflowControllerDeleteStatusWorkflow.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: StatusWorkflowItem;
      }>;
    })
  );
}

statusWorkflowControllerDeleteStatusWorkflow.PATH = '/status-workflow/{id}';
